import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'age'
})
export class AgePipe implements PipeTransform
{

  /**
   * Calculates age from date of birth string.
   *
   * @param dobString Date of birth string
   */
  public transform(dobString: string): any
  {
    const today = new Date();
    const birthDate = new Date(dobString);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate()))
    {
      age--;
    }

    return age;
  }

}
